import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Hourglass } from "lucide-react";

const STATUS = { in_attesa: "IN ATTESA", assegnato: "ASSEGNATO", annullato: "ANNULLATO", scaduto: "SCADUTO" };

// Lista d'attesa (vista admin)
export const AdminWaitlist = () => {
  const [entries, setEntries] = useState([]);
  useEffect(() => { api.get("/admin/waitlist").then((r) => setEntries(r.data.entries || [])).catch(() => {}); }, []);
  const waiting = entries.filter((e) => e.status === "in_attesa");

  return (
    <div className="paper-card p-5 mt-6" data-testid="admin-waitlist-panel">
      <div className="flex items-center gap-2 mb-3">
        <Hourglass className="w-5 h-5 text-labor-terracotta" />
        <h3 className="font-display text-xl">Lista d'attesa</h3>
        <span className="text-xs text-labor-muted">({waiting.length} in coda · quando un posto si libera viene assegnato al primo in coda)</span>
      </div>
      {entries.length === 0 ? <div className="text-sm text-labor-muted">Nessuno in lista d'attesa.</div> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-xs uppercase tracking-widest text-labor-muted border-b border-labor-border">
              <th className="py-2 pr-3">Data</th><th className="pr-3">Ora</th><th className="pr-3">Assistito</th><th className="pr-3">Servizio</th><th>Stato</th>
            </tr></thead>
            <tbody>
              {entries.map((e) => (
                <tr key={e.id} className="border-b border-labor-border" data-testid={`admin-waitlist-${e.id}`}>
                  <td className="py-2 pr-3 whitespace-nowrap">{e.slot_date}</td>
                  <td className="pr-3">{e.slot_time}</td>
                  <td className="pr-3">{e.user_name} {e.user_phone && <a href={`tel:${e.user_phone}`} className="text-labor-olive text-xs ml-1">{e.user_phone}</a>}</td>
                  <td className="pr-3">{e.service_name}</td>
                  <td><span className={`text-xs px-2 py-0.5 ${e.status === "in_attesa" ? "bg-labor-warning text-white" : e.status === "assegnato" ? "bg-labor-italianGreen text-white" : "bg-labor-border text-labor-muted"}`}>{STATUS[e.status]}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
